<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 军校招生 -->
    <div class="military_school studyway_common_father">
        <div class="banner">
            <img src="/imgs/wayToStudy/main/banner_tool.png" alt="">
        </div>
        <div class="main">
            <h6 class="main_title">途径介绍</h6>
            <div class="main_box">
                <p>普通升学是指不借助其他途径获得高考加分或录取优惠（全国和地方加分也视为普通升学），仅通过正常参加高考进入大学的方式，目前仍然是大部分学生使用的方式。</p>
            </div>    
        </div>
        <div class="benefit main">
            <h6 class="main_title">报考条件</h6>
            <div class="main_box">
                <p>普通升学无特殊报考条件。</p>
            </div>
        </div>
        <div class="benefit main">
            <h6 class="main_title">备考须知</h6>
            <div class="main_box">
                <p>尽管普通升学目前是大部分学生所采用的升学途径。但从往年的数据来看，普通升学进名校的几率在逐年减少，多种升学途径综合考虑是实现最优升学的必然路径。</p>               
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
     data() {
        return {}
    },
    methods: {},
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    @import "../study_way_common.less";
    // .studyway_common_father{
    //     padding: 0;
    // }
    .main{
        // padding: 20px;
        .main_title{
            margin-bottom: 0;
        }
    }
    .military_school {
        .liucheng {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    text-align: center;
                    line-height: 50px;
                    /* width: 189px; */
                    height: 50px;
                    /* padding-right: 60px; */
                    background: url(/imgs/wayToStudy/common/icon_liucheng.png) no-repeat right center;
                    margin-right: 20px;
                    padding-right: 53px;
                    background-size: 20px 20px;
                    // &:last-child {
                    //     padding-right: 0px;
                    // }
                }
            }
        }
        .universities  ul {
            overflow: hidden;
            width: 933px;
            li {
                font-size: 14px;
                box-sizing: border-box;
                float: left;
                width: 25%;
                border: 1px solid #eaeaea;
                margin-left: -1px;
                margin-top: -1px;
                min-height: 42px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 20px;
                text-align: center;
                &:nth-child(4n+1) {
                    margin-left: 0px;
                }
                &:nth-child(-n + 4) {
                    margin-top: 0px;
                }
            }
    }
        
    }
    
</style>